import { Expose } from "class-transformer";
import { CmsProductIseeRequirementEnum } from "../../enums/cms-product-isee-requirement.enum";
import { CmsProductManageWithBonusxEnum } from "../../enums/cms-product-manage-with-bonusx.enum";
import { CmsProductStatusEnum } from "../../enums/cms-product-status.enum";
import { CmsProductTypeEnum } from "../../enums/cms-product-type.enum";
import { CmsCollectionMetadataAttributes } from "../cms-collection-metadata-attributes/cms-collection-metadata-attributes.entity";
import { CmsProductGeographicalArea } from "../cms-product-geographical-area/cms-product-geographical-area.entity";
import { CmsProductImageApiResponse } from "../cms-product-image-api-response/cms-product-image-api-response.entity";
import { CmsProductMainCta } from "../cms-product-main-cta/cms-product-main-cta.entity";
import { CmsProductValue } from "../cms-product-value/cms-product-value.entity";
import { CmsTagApiResponse } from "../cms-tag-api-response/cms-tag-api-response.entity";
import { ICmsProduct } from "./cms-product.entity.interface";

export class CmsProduct extends CmsCollectionMetadataAttributes implements ICmsProduct {
  @Expose()
  name!: string;

  @Expose()
  uniqueIdentifier!: string;

  @Expose()
  tags!: CmsTagApiResponse;

  @Expose()
  title!: string;

  @Expose()
  mainImage!: CmsProductImageApiResponse;

  @Expose()
  cashbackFromPartner!: CmsProductValue[];

  @Expose()
  maxIsee!: number;

  @Expose()
  deadlineDate!: string;

  @Expose()
  startDate!: string;

  @Expose()
  bonusAsFundsRunOut!: boolean;

  @Expose()
  mainCta: CmsProductMainCta | null = null;

  @Expose()
  maxNumberOfConcurrentProcedures!: number;

  // Optional properties
  @Expose()
  freeBlock?: string;

  @Expose()
  shortDescription?: string;

  @Expose()
  description?: string;

  @Expose()
  eligibles?: string;

  @Expose()
  benefitsAndAmounts?: string;

  @Expose()
  duration?: string;

  @Expose()
  requisites?: string;

  @Expose()
  necessaryDocuments?: string;

  @Expose()
  applicationResult?: string;

  @Expose()
  finalizedPracticeMessage?: string;

  @Expose()
  requiredIsee?: CmsProductIseeRequirementEnum;

  @Expose()
  manageWithBonusx?: CmsProductManageWithBonusxEnum;

  @Expose()
  requestableFrom?: string;

  @Expose()
  requestableTo?: string;

  @Expose()
  requestableFromTier?: string;

  @Expose()
  status?: CmsProductStatusEnum;

  @Expose()
  type?: CmsProductTypeEnum;

  @Expose()
  geographicalArea?: CmsProductGeographicalArea;
}
